import React from 'react';

export const ZendeskSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18.8571 14.7536V31.4835H5L18.8571 14.7536ZM18.8571 8.75C18.8571 10.5876 18.1271 12.3499 16.8278 13.6492C15.5284 14.9486 13.7661 15.6785 11.9286 15.6785C10.091 15.6785 8.32868 14.9486 7.02933 13.6492C5.72997 12.3499 5 10.5876 5 8.75H18.8571ZM21.1399 31.485C21.1399 29.6474 21.8699 27.8851 23.1693 26.5857C24.4686 25.2864 26.2309 24.5564 28.0685 24.5564C29.9061 24.5564 31.6684 25.2864 32.9677 26.5857C34.2671 27.8851 34.997 29.6474 34.997 31.485H21.1399ZM21.1399 25.4814V8.75H35L21.1399 25.4799V25.4814Z"
			fill="#03363D"
		/>
	</svg>
);
